<script type="text/babel">
import ManagesModalState from "dashboard-js/mixins/ManagesModalState";
import RestoreScrollOnPageBack from "dashboard-js/mixins/RestoreScrollOnPageBack";

export default {
  mixins: [ManagesModalState, RestoreScrollOnPageBack],

  props: ["course", "question", "user"],

  data() {    
    return {
      entry_id: null,
      selectedAnswers: [],
      text: null,
    };
  },

  created() {
    if (!this.shouldShowQuestion) {
      const currentSortOrder = this.question.sort_order;
      const nextQuestion = this.course.course_question.find(
        (question) => question.sort_order === currentSortOrder + 1
      );

      if (nextQuestion) {
        window.location.href = `/school/course/${this.course.id}/question/${nextQuestion.id}`;
      }
    }

    if (this.isFirstQuestion) {
      axios
        .post(route("influencer.school.entry.save"), {
          course_id: this.course.id,
          score: 0,
          last_entry_result: false,
        })
        .then((response) => (this.entry_id = response.data.entry_id));
    }
  },

  methods: {
    isDisabled(answer) {
      return (
        this.question.type === "multi choice" &&
        this.selectedAnswers.length >= this.question.max_choices &&
        !this.isSelected(answer)
      );
    },
    isSelected(answer) {
      return this.selectedAnswers.some(
        (selectedAnswer) => selectedAnswer.id === answer.id
      );
    },
    navigateToSlides() {
      const coursePath = `/school/course/${this.course.id}`;
      window.location.pathname = `${coursePath}/overview`;
    },
    navigateToLastSlide() {
      const lastSlide = this.course.course_slide.slice(-1)[0];
      const coursePath = `/school/course/${this.course.id}`;
      window.location.pathname = `${coursePath}/slide/${lastSlide.id}`;
    },
    navigateToVideo() {
      const coursePath = `/school/course/${this.course.id}`;
      window.location.pathname = `${coursePath}/video`;
    },
    onAnswersUpdate(answer) {
      if (this.question.type === "single choice") {
        this.selectedAnswers = [answer];
      } else {
        const index = this.selectedAnswers.findIndex(
          (selectedAnswer) => selectedAnswer.id === answer.id
        );

        index === -1
          ? this.selectedAnswers.push(answer)
          : this.selectedAnswers.splice(index, 1);
      }
    },
    onQuestionBack() {
      const currentSortOrder = this.question.sort_order;
      if (currentSortOrder > 1) {
        const prevQuestion = this.course.course_question.find(
          (question) => question.sort_order === currentSortOrder - 1
        );
        if (prevQuestion) {
          window.location.href = `/school/course/${this.course.id}/question/${prevQuestion.id}`;
        }
      }
    },
    onQuestionNext() {
      const currentSortOrder = this.question.sort_order;
      const nextQuestion = this.course.course_question.find(
        (question) => question.sort_order === currentSortOrder + 1
      );

      const postData = {
        entry_id: this.entry_id ? this.entry_id : this.course.course_user_entry.id,
        question_id: this.question.id,
      };

      if (this.question.type === "free") {
        postData.text = this.text;
      } else {
        postData.answers = this.selectedAnswers;
      }

      if (nextQuestion) {
        const routeName =
          this.question.type === "free"
            ? "influencer.school.answers.free-type.save"
            : "influencer.school.answers.save";

        if (this.question.type === "free" && !this.isTextValid) return;

        axios.post(route(routeName), postData);
        window.location.href = `/school/course/${this.course.id}/question/${nextQuestion.id}`;
      }
    },

    onQuestionsSubmit() {
      const postData = {
        entry_id: this.entry_id ? this.entry_id : this.course.course_user_entry.id,
        question_id: this.question.id,
      };

      if (this.question.type === "free") {
        postData.text = this.text;
      } else {
        postData.answers = this.selectedAnswers;
      }

      if (this.question.type === "free" && !this.isTextValid) return;

      axios.post(
        route(
          this.question.type === "free"
            ? "influencer.school.answers.free-type.save"
            : "influencer.school.answers.save"
        ),
        postData
      );

      axios
        .post(route("influencer.school.result.create"), {
          course_id: this.course.id,
          entry_id: this.entry_id ? this.entry_id : this.course.course_user_entry.id,
        })
        .then((response) => {
          if (response.data.success) {
            window.location.href = `/school/course/${this.course.id}/result`;
          }
        });
    },
  },

  computed: {
    currentQuestion() {
      return this.question.sort_order;
    },
    isFirstQuestion() {
      return this.currentQuestion === 1;
    },
    isLastQuestion() {
      return this.currentQuestion === this.course.course_question.length;
    },
    isTextValid() {
      if (!this.text) return false;
      if (this.text && this.text.length) {
        const textLength = this.text.length;
        return (
          textLength >= this.question.min_text_input &&
          textLength <= this.question.max_text_input
        );
      }
    },
    shouldShowQuestion() {
      if (!this.question.dependent_answer_id || !this.question.dependent_question_id)
        return true;

      return this.course.course_user_entry.course_user_answers.some(
        (answer) =>
          answer.question_id === this.question.dependent_question_id &&
          answer.answer_id === this.question.dependent_answer_id
      );
    },
  },
};
</script>
